import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"

if (process.env.NODE_ENV === "production") {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

const container = document.getElementById("root")
const root = ReactDOM.createRoot(container)
root.render(<App />)

